import ActivationTask from '@/app/activations/models/ActivationTask'

/* eslint-disable camelcase */
export default class ActivationDetail {
  constructor ({ id, name, schema, created_at, tasks }) {
    this.id = id
    this.name = name || ''
    this.schema = schema
    this.createdAt = created_at
    this.tasks = tasks.map(rawTask => new ActivationTask(rawTask))
  }
}



// WEBPACK FOOTER //
// ./src/app/activations/models/ActivationDetail.js